<template>
  <div id="process" class="process" v-show="appear">
    <div class="process-content">
      <img src="/static/images/loading.gif">
      <p>loading</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'process',
  props: {
    appear: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
#process
  position absolute
  z-index 100
  width 100%
  height 100%
  top 0px
  left 0px
  text-align center

  .process-content
    position absolute
    display block
    width 100px
    height 100px
    top 50%
    left 50%
    padding 25px 0px
    margin-top -50px
    margin-left -50px
    border-radius 4px
    box-sizing border-box
    img
        width 20px
        height 20px
</style>



// WEBPACK FOOTER //
// loading.vue?536ef1dd